import useRedux from "./useRedux";

export const useHasPermission = (path: string | string[]) => {
  const {
    selector: {
      resourceList,
    },
  } = useRedux(s => s.userRole);
  if (!path || typeof path === 'string' && ['/', '/403', '404'].includes(path)) {
    return true;
  }
  let hasPermisson = false;
  if (typeof path === 'string') {
    hasPermisson = Boolean(resourceList?.find((item: any) => item.routePath === path && Boolean(item.selected)));
  } else {
    for (let i = 0; i < path.length; i++) {
      if (resourceList?.find((item: any) => item.routePath === path[i])) {
        hasPermisson = true;
        break;
      }
    }
  }
  return hasPermisson;
};

